<script>
export default {
  name: "CrmSummaryCards",
  props: {
    credit: {
      type: [Number, String],
      default: 0
    },
    packageCount: {
      type: [Number, String],
      default: 0
    },
    voucherCount: {
      type: [Number, String],
      default: 0
    },
    creditRoute: {
      type: String,
      default: "/spa-wallet/credit"
    },
    packageRoute: {
      type: String,
      default: "/spa-wallet/package"
    },
    voucherRoute: {
      type: String,
      default: "/spa-wallet/voucher"
    },
    dataTestPrefix: {
      type: String,
      default: "home"
    }
  },
  computed: {
    baseUrl() {
      return process.env.BASE_URL || "/";
    }
  }
};
</script>

<template>
  <section class="crm-summary" :data-test="`${dataTestPrefix}-summary`">
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-credit-summary`"
      @click="$router.push(creditRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${baseUrl}svg/credit.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <strong class="crm-summary__value">
          {{ numeralFormat(credit) }}
          <span class="crm-summary__unit">{{ $t("currency_unit") }}</span>
        </strong>
        <span class="crm-summary__label">{{ $t("credit_balance") }}</span>
      </div>
    </button>
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-package-summary`"
      @click="$router.push(packageRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${baseUrl}svg/package.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <strong class="crm-summary__value">
          {{ packageCount }}
          <span class="crm-summary__unit">{{ $t("list") }}</span>
        </strong>
        <span class="crm-summary__label">{{ $t("package_balance") }}</span>
      </div>
    </button>
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-voucher-summary`"
      @click="$router.push(voucherRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${baseUrl}svg/gift-02.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <strong class="crm-summary__value">
          {{ voucherCount }}
          <span class="crm-summary__unit">{{ $t("list") }}</span>
        </strong>
        <span class="crm-summary__label">{{ $t("voucher_balance") }}</span>
      </div>
    </button>
  </section>
</template>

<style lang="scss" scoped>
.crm-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 14px 0;
}

.crm-summary__card {
  position: relative;
  display: flex;
  min-width: 0;

  flex-direction: column;
  align-items: flex-start;
  border: 0;
  border-radius: 22px;
  background: #fff;
  padding: 20px 12px 20px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.06);
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.crm-summary__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background-color: var(--primary-color);
  -webkit-mask-image: var(--icon-url);
  mask-image: var(--icon-url);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}

.crm-summary__chevron {
  position: absolute;
  top: 23px;
  right: 16px;
  color: var(--primary-color);
  font-size: var(--text-lg);
}

.crm-summary__content {
  min-width: 0;
  margin-top: 0.75rem;
}

.crm-summary__value {
  display: block;
  overflow: hidden;
  color: #222;
  font-size: var(--text-xl);
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crm-summary__unit {
  font-size: var(--text-md);
  font-weight: 500;
}

.crm-summary__label {
  display: block;
  overflow: hidden;

  color: #b1b1b1;
  font-size: var(--text-sm);
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
